export class ConfirmModalData {
  /* eslint-disable no-useless-constructor */
  constructor (
    public resolve: ((state: boolean) => void) | undefined,
    public question: string = 'Are you sure?',
    public title: string = 'Are you sure?',
    public confirmButton: string = 'CONFIRM',
    public cancelButton: string = 'CANCEL') {
  }
}
